import { Component, OnInit } from "@angular/core";
import { UserService } from "../shared/user.service";
import { EmployeeDepositsService } from "../service/employee-deposits.service";
import { Form161FormalyService } from "../service/form161Formaly.service";
import { Form161EmployeeData, FormalyStatus } from "../model/form161Formaly.model";
import { SelectItem, SortEvent } from "primeng/primeng";
import { HttpErrorResponse } from "@angular/common/http";

@Component({
  selector: "form161-forlmaly-list",
  templateUrl: "./form161-forlmaly-list.component.html",
  styleUrls: ["./form161-forlmaly-list.component.css"],
})
export class Form161FormalyListComponent implements OnInit {
  userDetails: any;

  msgs: any[] = [];

  enumFormalyStatus = FormalyStatus;

  employersList: SelectItem[] = [];

  selectedCustomerId = "";

  employeesList: any[] = [];

  selectedEmpId: string = '';

  employeesData: Form161EmployeeData[] = [];

  isForm161Allowed: boolean = false;
  
  cols: any[] = [
    { field: 'RecordId', header: 'מספר טופס' },
    { field: 'EmployeeIdentityNumber', header: 'ת. ז.' },
    { field: 'EmployeeFirstName', header: 'שם פרטי' },
    { field: 'EmployeeLastName', header: 'שם משפחה' },
    { field: 'StartDate', header: 'תחילת מילוי בפורטל' },
    { field: 'FinishDate', header: 'סיום תהליך בפורטל' },
    { field: 'StatusName', header: 'סטטוס בפורטל' },
    { field: 'SignatureStatus', header: 'סטטוס חתימה' },
    { field: 'FormalyRequestTreatmentStatus', header: 'סטטוס טיפול בבקשה' },
    { field: 'FormalyStatusUpdateDate', header: 'עדכון אחרון פורמלי' },
  ];

  constructor(
    private userService: UserService,
    private dataService: EmployeeDepositsService,
    private form161FormalyService: Form161FormalyService
  ) {}

  ngOnInit() {
    this.userService.getUserClaims().subscribe((response) => {
      this.userDetails = response;
      

      if (this.userDetails && (this.userDetails.ClientRoleSupport || this.userDetails.ClientRoleAdministration || this.userDetails.ClientRoleSemiAdministrator)) {
        this.dataService.getCustomers().subscribe((result: any) => {
          this.employersList = result;
          this.isForm161Allowed = true;
        },
        (err: HttpErrorResponse) => {
          this.showMessage('error', '', 'תקלה בקבלת רשימת מעסיקים');
        });
      } else {

        this.form161FormalyService.getIsForm161Allowed().subscribe((resultData) => {
          if (resultData) {
            this.isForm161Allowed = true;
            this.selectedCustomerId = this.userDetails.CurrentCustomerIdentityNumber;
            this.getEmployeesWithForm161(this.selectedCustomerId);   
          } else {
            // not allowed to 161
            this.isForm161Allowed = false;
          }
        },
        (err: HttpErrorResponse) => {
          this.showMessage('error', '', 'תקלה בקבלת פרטי מעסיק');
        });


        
      }


    });

    
  }

  // setSelectdEmployee(event) {
  //   let v = event.value;
  //   this.selectedEmpId = v;
  // }

  // getEmployersData = (selectedEmployer: string) => {
  //   this.dataService.getEmp(selectedEmployer).subscribe((result: any) => {
  //     this.employeesList = result;
  //     //console.log(this.employeesList);
  //     this.employeesList.unshift({ label: "כל העובדים", value: null });
  //   });
  // };

  getEmployeeData = () => {
    this.form161FormalyService
      .getEmployeeData(this.selectedCustomerId, this.selectedEmpId)
      .subscribe((response: any) => {
        this.employeesData = response;
        //console.log(this.employeesData);
      });
  };

  getEmployeesWithForm161 = (customerIdentity: string) => {
    this.form161FormalyService
      .getEmployeesWithForm161(customerIdentity)
      .subscribe((response : any) => {
        // this.employeesList = response
        // console.log(this.employeesList);

        let res: any[] = response;
        this.employeesList = res.map(f=>{ return {value: f.EmployeeIdentityNumber, label: f.EmployeeIdentityNumber + ' ' + f.EmployeeFirstName + ' ' + f.EmployeeLastName};});
        console.log(this.employeesList );


      });
  };

  getStatusColor(formStatusId) {
    if (formStatusId==this.enumFormalyStatus.Form161FormalyStatus_Draft) {
      return 'orange';
    } else if (formStatusId==this.enumFormalyStatus.Form161FormalyStatus_OrderedAndWaitingForDataCompletition) {
      return 'blue';
    } else if (formStatusId==this.enumFormalyStatus.Form161FormalyStatus_SentToFormaly) {
      return 'green';
    } else if (formStatusId==this.enumFormalyStatus.Form161FormalyStatus_Finished) {
      return 'black';
    } else if (formStatusId==this.enumFormalyStatus.Form161FormalyStatus_Failed) {
      return 'red';
    } else {
      return '';
    }
  }

  showMessage(type, summaryMessage, message): void {
    this.msgs = [];
    this.msgs.push({
      severity: type,
      summary: summaryMessage,
      detail: message,
    });
  }


}



// WEBPACK FOOTER //
// C:/ProjectsOnGit/USilence/USilence/Client/src/app/form161-forlmaly-list/form161-forlmaly-list.component.ts